// extracted by mini-css-extract-plugin
module.exports = {"main_page":"MySpace_main_page__21jru","main_header":"MySpace_main_header__3TQzi","content":"MySpace_content__3YBeO","tabs":"MySpace_tabs__3vP1L"};